import { PureComponent, Fragment } from 'react';
import Html from 'Component/Html';
import ShowMore from 'Component/ShowMore';

import './ProductDescription.style';

export default class ProductDescription extends PureComponent {
    renderAttr(attr) {
        if (!attr) return null;
        const { attribute_id, attribute_label, attribute_value } = attr;

        if (!attribute_value) {
            return null;
        }

        return (
            <Fragment key={ attribute_id }>
                <h4>{ attribute_label }</h4>
                <Html content={ attribute_value } />
            </Fragment>
        )
    }

    render() {
        const { description, addressability, instructions, benefits } = this.props;

        return (
            <ShowMore
                mix={ { block: 'ProductDescription' } }
                isOpen={ true }
            >
                <div block="ProductSection" elem="Heading">
                    <h3 block="ProductSection" elem="HeadingTitle">
                        { __('Description') }
                    </h3>
                </div>
                <div block="ProductSection" elem="Content">
                    <div block="ProductDescription">
                        <meta itemProp="description" content={ description } />
                        <Html content={ description } />
                        { [addressability, instructions, benefits].map(attr => this.renderAttr(attr))  }
                    </div>
                </div>
            </ShowMore>
        );
    }
}
